import { render, staticRenderFns } from "./CreateCampaignSetupsWrapper.vue?vue&type=template&id=1d7aef01&scoped=true"
import script from "./CreateCampaignSetupsWrapper.vue?vue&type=script&lang=js"
export * from "./CreateCampaignSetupsWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d7aef01",
  null
  
)

export default component.exports